import {h, Component, Fragment} from 'preact';
import Config from "../config";
import Page from "../../../services/page-data-feed";
import IframeMessages from "../../../services/iframe-messages";
import MobilePage from "../../jamibet/utils/mobile-page.jsx";

import DefaultMobileHeader from "../mobile-components/site/mobile-header";

let MobileHeaderOverride = null;
export function setMobileHeader(component) { MobileHeaderOverride = component; }
import MobileFooter from "../mobile-components/site/mobile-footer";
import MenuRight from "../../jamibet/mobile-components/site/menu-right";
import MenuLeft, {HorizontalTopMenu} from "../../jamibet/mobile-components/site/menu-left";

import PopupLogin from "../mobile-components/site/popup-login";
import PopupRegister from "../mobile-components/site/popup-register";
import PopupRecovery from "../../jamibet/mobile-components/site/popup-recovery";
import MobileBottomNav from '../../jamibet/mobile-components/site/mobile-bottom-nav';
import Ticket, { TicketOpenButton } from "../../jamibet/mobile-pages/ticket";


IframeMessages.onCartNavigation = () => {MobilePage.toggleTicket();Page.rerender();}
IframeMessages.onSportNavigation = () => {MobilePage.setPage({name: 'home', data: {view: 'menu', sport: '/sport/1'}});Page.rerender();}

export default function FullSite({children, ...props}) {
	const MobileHeader = MobileHeaderOverride || DefaultMobileHeader;
	return <div class="mobile-page bg-harif-800 font-roboto">
		{!Config.hideHeader && <MobileHeader />}
		{!Config.hideHeader && <HorizontalTopMenu onClick={null} />}
		<MobileBottomNav />
		<div class={"min-h-screen"+(props['class'] ? " "+props['class'] : '')}>{children}</div>
		
		{!Config.hideFooter && !props.hideFooter && <MobileFooter />}

		<TicketOpenButton />
		<Ticket />
		
		<MenuLeft />
		<MenuRight />

		<PopupLogin />
		<PopupRegister />
		<PopupRecovery />
	</div>;
}
